export default {
  de: {
    canvasLink: {
      close: 'Schließen',
      copiedToClipboard: 'Erfolgreich in die Zwischenablage kopiert',
      copyToClipboard: 'In die Zwischenablage kopieren',
      noteRights: 'Bitte beachten Sie den Rechtehinweis',
      noteRights_plural: 'Bitte beachten Sie die Rechtehinweise',
      share: {
        envelope: 'Per Mail teilen',
        facebook: 'Auf Facebook teilen',
        pinterest: 'Auf Pinterest teilen',
        twitter: 'Auf Twitter teilen',
        whatsapp: 'Per WhatsApp teilen',
      },
      shareLink: 'Link auf diese Seite teilen',
    },
  },
  en: {
    canvasLink: {
      close: 'Close',
      copiedToClipboard: 'Copied successfully to the clipboard',
      copyToClipboard: 'Copy to clipboard',
      noteRights: 'Please note the rights statement',
      noteRights_plural: 'Please note the rights statements',
      share: {
        envelope: 'Share via mail',
        facebook: 'Share on Facebook',
        pinterest: 'Share on Pinterest',
        twitter: 'Share on Twitter',
        whatsapp: 'Share via WhatsApp',
      },
      shareLink: 'Share link to this page',
    },
  },
};
